import { render, staticRenderFns } from "./PageMarket.vue?vue&type=template&id=12942a1f"
import script from "./PageMarket.vue?vue&type=script&lang=js"
export * from "./PageMarket.vue?vue&type=script&lang=js"
import style0 from "./PageMarket.vue?vue&type=style&index=0&id=12942a1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports